import { render, staticRenderFns } from "./PddList.vue?vue&type=template&id=49cb14e3&scoped=true"
import script from "./PddList.vue?vue&type=script&lang=js"
export * from "./PddList.vue?vue&type=script&lang=js"
import style0 from "./PddList.vue?vue&type=style&index=0&id=49cb14e3&prod&lang=scss&scoped=true"
import style1 from "./PddList.vue?vue&type=style&index=1&id=49cb14e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cb14e3",
  null
  
)

export default component.exports